import { ToneOption } from "../model/tone-option.enum";
import TEMPLATE_1 from "../assets/images/template-1.jpg";
import TEMPLATE_2 from "../assets/images/template-2.jpg";
import TEMPLATE_3 from "../assets/images/template-3.jpg";

export const templateRadioOptions = [
    { value: "template 1", src: TEMPLATE_1 },
    { value: "template 2", src: TEMPLATE_2 },
    { value: "template 3", src: TEMPLATE_3 },
];

export const toneOptions = [
    { value: ToneOption.FORMAL, label: "ทางการ/มืออาชีพ" },
    { value: ToneOption.CASUAL, label: "เป็นกันเอง/เข้าถึงง่าย" },
    { value: ToneOption.SOCIAL, label: "เชิญชวน/ดึงดูดความสนใจ" },
];